module.exports = __webpack_public_path__ + "static/media/clyde1932.152d0c22.png";